<template>
	<div class="page company parallaxY">
		<!-- aboutCompany -->
		<div id="vision" class="topAnchor"></div>
		<section class="secWrap aboutCompany" ref="sectionAboutCompany">
			<div class="topCenterVision parallaxChild animation" ref="paral1" data-speed='13'>
				<p>
				함께 걸어가고,<br>
				성장하고, 도전합니다.<br>
				전문성과 신뢰를 쌓고,<br>
				사회에 나눕니다.
				</p>
			</div>

			<div id="businessfield" class="mainCategory parallaxChild shadow" ref="paral2" data-speed='22'>
				<div class="topWrap">
					<img src="@/assets/images/ico-company-main-category@2x.png" alt="">
				</div>
				<div class="contentWrap">
					<h3>주요 사업 분야</h3>
					<p>시스템통합/관리</p>
					<p>솔루션개발/유통</p>
					<p>IT컨설팅/아웃소싱</p>
					<p>인력개발사업</p>
				</div>
			</div>

			<div class="companyTopVideo parallaxChild animation" ref="paralVideo" data-speed='3' @click="youtubeClick">
				<div v-show="youtubeThumbShow" class="youtubeThumb imgWrap">
					<img src="@/assets/images/company-yt-thumbnail@2x.png" alt="">
				</div>
				<youtube v-show="videoId" class="youtubeContainer" ref="youtube" :video-id="videoId" :player-vars="playerVars"></youtube>
			</div>

			<div id="aboutcompany" class="aboutCompanyIntro parallaxChild shadow" ref="paral3" data-speed='-14'>
				<div class="topWrap">
					<h3>
						<p><span>About</span> Company</p>
						<span>회사소개</span>
					</h3>
				</div>
				<div class="contentWrap">
					<h3>㈜두손소프트는?</h3>
					<div v-html="$store.state.basicInfo.aboutUs"></div>
				</div>
			</div>
		</section>

		<!-- aboutTeam -->
		<section id="aboutteam" class="secWrap aboutTeam">
			<!-- right -->
			<div class="aboutTeamLeft parallaxChild" ref="aboutTeamL" data-speed='23'>
				<div class="topWrap">
					<img src="@/assets/images/img-company-aboutteam@2x.png" alt="">
				</div>
				<div class="contentWrap">
					<h3>
						<span>조직소개</span>
						<p><span>About</span> Team</p>
					</h3>
				</div>
			</div>
			<!-- left -->
			<div class="aboutTeamRight parallaxChild" ref="aboutTeamR" data-speed='-3'>
				<div class="topWrap">
					<p>
						두손소프트는<br>
						국내외 보험사, 카드 등의 금융분야와 커머스 분야를 아우르는<br class="mobileHide tabletHide">
						대기업 주요 프로젝트를 성공적으로 구축한 경험을 보유하고 있으며,<br class="mobileHide tabletHide">
						고객과 함께 고민하고 현장의 소리를 듣고 함께 애로 사항을 해결하는 기업입니다.<br>
						<br class="mobileBlock tabletBlock">
						금융분야의 다양한 솔루션과 서비스를 제공 함으로<br class="mobileHide tabletHide">
						고객과 함께 지속적으로 발전해 나가도록 하겠습니다.
					</p>
				</div>
				<div class="contentWrap">
					<h4>Humanism Through Technology & <br class="mobileBlock">Next Business Leader.</h4>
					<div class="diagramWrap">
						<ul class="diagram">
							<li class="item strategyNPlanning">
								<div class="diagramItemWrap">
									<div class="ico">
										<img src="@/assets/images/ico-company-aboutteam-ifg-1@2x.png" alt="Strategy & Planning Div." class="imgDiagram">
									</div>
									<h3>Strategy & Planning Div.</h3>
									<p class="txt">Planning<br>UI/UX</p>
								</div>
							</li>
							<li class="item siGroup">
								<div class="diagramItemWrap">
									<div class="ico">
										<img src="@/assets/images/ico-company-aboutteam-ifg-2@2x.png" alt="SI Group" class="imgDiagram">
									</div>
									<h3>SI Group</h3>
									<p class="txt">PM Group<br>Development<br>PMO</p>
								</div>
							</li>
							<li class="item rndLaboratory">
								<div class="diagramItemWrap">
									<div class="ico">
										<img src="@/assets/images/ico-company-aboutteam-ifg-3@2x.png" alt="R&D Laboratory" class="imgDiagram">
									</div>
									<h3>R&D Laboratory</h3>
									<p class="txt">Strategic Lab<br>Technology Lab</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>

		<!-- history -->
		<section id="history" class="secWrap history">
			<div class="topWrap">
				<h3 class="titleWrap" data-aos="fade">
					<p class="titleTxt first">{{this.history.top.title1}}</p>
					<p class="titleTxt second">{{this.history.top.title2}}</p>
				</h3>
				<div class="icoWrap"><img class="icoImg" src="@/assets/images/ico-company-history@2x.png" alt="history icon"></div>
			</div>
			<div class="contentWrap">
				<div class="mobileBlock verticalLine"></div>
				<ul class="historyLists">
					<li class="listItem" v-for="(elm, index) in history.list" :key="index" data-aos="fade" :data-aos-delay="index*50">
						<h4 class="year">{{elm.year}}</h4>
						<div class="contentInnerWrap">
							<div class="flexWrap">
								<div class="flexContent" v-for="(cont, conIndex) in elm.content" :key="conIndex">
									<h5>{{cont.title}}</h5>
									<p class="txtCont" v-html="cont.detail"></p>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div class="bottomWrap">
				<h3 class="titleWrap">
					<p class="yearTxt">{{this.history.bottom.year}}</p>
					<p class="titleTxt">{{this.history.bottom.txt}}</p>
				</h3>
			</div>
		</section>

		<!-- certification -->
		<section id="certification" class="secWrap certification">
			<div class="topWrap" data-aos="fade">
				<h3 class="titleWrap">
					<p class="titleTxt first">{{this.certificationList.top.title1}}</p>
					<p class="titleTxt second">{{this.certificationList.top.title2}}</p>
					<p class="titleTxt third">{{this.certificationList.top.title3}}</p>
				</h3>
				<div class="icoWrapL"><img class="icoImg" src="@/assets/images/ico-company-certification-l@2x.png" alt="certification icon"></div>
				<div class="icoWrapR"><img class="icoImg" src="@/assets/images/ico-company-certification-r@2x.png" alt="certification icon"></div>
			</div>
			<div class="contentWrap" data-aos="fade-up">
				<ul class="certificationLists">
					<li class="listItem" v-for="(elm, index) in certificationList.list.item" :key="index">
						<h4 class="titleTxt"><span>{{elm.title}}</span></h4>
						<div class="contentInnerWrap">
							<div class="imgWrap">
								<img :src="elm.imgUrl" alt="">
							</div>
						</div>
					</li>
				</ul>
			</div>
		</section>

		<!-- patent -->
		<section id="patent" class="secWrap patent">
			<div class="topWrap" data-aos="fade">
				<h3 class="titleWrap">
					<p class="titleTxt first">{{this.patentList.top.title1}}</p>
					<p class="titleTxt second">{{this.patentList.top.title2}}</p>
				</h3>
				<div class="icoWrap"><img class="icoImg" src="@/assets/images/ico-compnay-patent-list@2x.png" alt="certification icon"></div>
			</div>
			<div class="contentWrap" data-aos="fade-up">
				<ul class="patentLists">
					<li class="listItem" v-for="(elm, index) in patentList.list.item" :key="index">
						<h4 class="titleTxt"><span>{{elm.title}}</span></h4>
						<div class="contentInnerWrap">
							<div class="imgWrap">
								<img :src="elm.imgUrl" alt="">
							</div>
						</div>
					</li>
				</ul>
			</div>
		</section>

		<!-- partner -->
		<section id="partner" class="secWrap partner">
			<div class="topWrap" data-aos="fade">
				<h3 class="titleWrap">
					<p class="titleTxt first">{{this.partnerList.top.title1}}</p>
					<p class="titleTxt second">{{this.partnerList.top.title2}}</p>
				</h3>
			</div>
			<div class="contentWrap" data-aos="fade-up">
				<ul class="partnerLists">
					<li class="listItem" v-for="(elm, index) in partnerList.list.item" :key="index">
						<div class="contentInnerWrap">
							<div class="imgWrap">
								<img :src="elm.imgUrl" alt="">
							</div>
						</div>
						<h4 class="titleTxt"><span>{{elm.title}}</span></h4>
					</li>
				</ul>
			</div>
		</section>

		<Footer />
	</div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
import Footer from '../components/Footer'
import { EventBus } from '../utils/event-bus'

export default {
	name: 'Company',
	components: {
		Footer
	},
	data () {
		return {
			parallaxVal: 0,
			parallaxAmount: 0.1,
			parallaxState: false,
			wH: 0,
			dH: 0,
			wW: 0,
			bgMoveVal: 80,
			ie: false,
			youtubeThumbShow: true,
			videoId: null,
			playerVars: {
				autoplay: 0,
				controls: 0,
				modestbranding: 1,
				loop: 1,
				playlist: ''
			},
			history: {
				top: {
					title1: 'TWOSONSOFT',
					title2: 'HISTORY'
				},
				bottom: {
					txt: '㈜두손소프트 설립',
					year: '2011'
				},
				list: [
					{
						year: 2019,
						content: [
							{
								title: '최근 수행 프로젝트',
								detail: '삼성생명<br>흥국화재<br>푸르덴셜생명<br>미래에셋생명<br>흥국생명<br>NH손보<br>한화생명(모바일 청약PJ)<br>CJ ENM<br>나이스평가정보 PJ'
							},
							{
								title: '특허 출원',
								detail: '복수의 이종 디바이스의<br>교차 이벤트를 통한 보험 청약 방법<br><br>모바일 청약에서<br>보험계약문서의 다운로드 및 뷰를<br>보증하는 방법<br><br>모바일 화면 제어 장치 및 방법<br>(신한생명 공동출원)'
							}
						]
					},
					{
						year: 2018,
						content: [
							{
								title: '파트너 등록',
								detail: 'IBM Watson IoT'
							},
							{
								title: '본사 이전',
								detail: 'JNK 타워 502호'
							}
						]
					},
					{
						year: 2017,
						content: [
							{
								title: '저작권 등록',
								detail: 'TS Web FC Note 솔루션<br>TS Web PDF Viewer 솔루션<br>TS Web Scanner 솔루션<br>'
							},
							{
								title: '본사 이전',
								detail: '대륭 포스트타워 3차'
							}
						]
					},
					{
						year: 2016,
						content: [
							{
								title: '협력 파트너 등록',
								detail: 'NH생명 협력 파트너 등록<br>교보생명 협력 파트너 등록<br>'
							},
							{
								title: '비지니스 파트너 등록',
								detail: '삼성SDS 비즈니스 파트너 등록<br>LG CNS 파트너 등록'
							}
						]
					},
					{
						year: 2015,
						content: [
							{
								title: '협력 파트너 등록',
								detail: 'SK텔레콤 협력 파트너 등록'
							},
							{
								title: '인증 및 증명',
								detail: '직접생산확인증명 (전산업무/SW개발)<br>INNO-BIZ 기술혁신형 중소기업 인증 (중소기업청)'
							}
						]
					},
					{
						year: 2014,
						content: [
							{
								title: '회원 등록',
								detail: '벤처기업협회 정회원 등록'
							},
							{
								title: '인증',
								detail: '기업부설연구소 인증<br>(한국산업기술진흥협회)'
							}
						]
					},
					{
						year: 2013,
						content: [
							{
								title: '등록',
								detail: '삼성생명 개발 협력사<br>한국IBM기술파트너<br>한화생명 개발 협력사<br>교보생명 개발 협력사'
							},
							{
								title: '인증 및 계약',
								detail: '벤처기업인증(기술보증기금)<br>숭실대학교 산학협력 계약'
							}
						]
					},
					{
						year: 2012,
						content: [
							{
								title: '등록',
								detail: 'CJ시스템즈 협력 파트너<br>삼성SDS 협력 파트너<br>다우데이타 Adobe 파트너'
							},
							{
								title: '설립',
								detail: '기업부설연구소'
							}
						]
					}
				]
			},
			certificationList: {
				top: {
					title1: '인증현황',
					title2: 'Certification',
					title3: 'List'
				},
				list: {
					item: [
						/* {
							title: '소프트웨어사업자',
							thumbUrl: require('@/assets/images/thumb-cert-software@2x.png'),
							link: ''
						},
						*/
					]
				}
			},
			patentList: {
				top: {
					title1: 'Patent List',
					title2: '특허현황'
				},
				list: {
					item: [
						/* {
							title: '보험청약 복수디바이스관련',
							thumbUrl: require('@/assets/images/thumb-patent-1@2x.png'),
							link: ''
						},
						 */
					]
				}
			},
			partnerList: {
				top: {
					title1: 'Partnership',
					title2: '고객현황'
				},
				list: {
					item: [
						/* {
							title: '삼성카드',
							partnerImgUrl: require('@/assets/images/partner-thumb-samsungcard@2x.png'),
							link: ''
						},
						*/
					]
				}
			}
		}
	},
	watch: {
		history: {
			deep: true,
			immediate: true,
			handler () {
				// console.log('The list of colours has changed!')
			}
		}
	},
	computed: {
		sT () { return window.scrollY },
		player () {
			return this.$refs.youtube.player
		}
	},
	created: function () {
		console.log('> Company : created')

		// Youtube
		EventBus.$on('basicinfo-load-complete', (youtubeUrl) => {
			console.log('youtubeUrl:', youtubeUrl)
			this.videoId = youtubeUrl
			this.playerVars.playlist = youtubeUrl
		})
		window.addEventListener('resize', this.onWinResize)
		AOS.init()
	},
	mounted () {
		console.log('> Company : mounted')
		// data load
		this.videoId = this.videoId || this.$store.state.basicInfo.youtube
		this.playerVars.playlist = this.playerVars.playlist || this.$store.state.basicInfo.youtube

		// history
		this.$axios.post(this.$store.state.dataUrl + '/twosonHistory')
			.then(response => {
				// console.log('historyData : ', response.data)
				this.history.list = []
				this.history.list = response.data
			})
			.catch(error => {
				console.log('* error : ' + error.response)
			})

		// certification
		this.$axios.post(this.$store.state.dataUrl + '/aboutUs?cate=' + 'certification')
			.then(response => {
				// console.log('certificationData : ', response.data)
				let data = response.data
				let dataObj
				let tempData
				this.certificationList.list.item = []
				for (var elm in data) {
					dataObj = {}
					tempData = data[elm]
					dataObj = {
						title: tempData.title,
						imgUrl: this.$store.getters.getUrlPrefix + tempData.mainImg,
						category: tempData.cate,
						idx: tempData.aboutUsNo,
						link: tempData.linkUrl || ''
					}
					this.certificationList.list.item.push(dataObj)
				}
			})
			.catch(error => {
				console.log('* error : ' + error.response)
			})

		// patent
		this.$axios.post(this.$store.state.dataUrl + '/aboutUs?cate=' + 'patent')
			.then(response => {
				// console.log('patentData : ', response.data)
				let data = response.data
				let dataObj
				let tempData
				this.patentList.list.item = []
				for (var elm in data) {
					dataObj = {}
					tempData = data[elm]
					dataObj = {
						title: tempData.title,
						imgUrl: this.$store.getters.getUrlPrefix + tempData.mainImg,
						category: tempData.cate,
						idx: tempData.aboutUsNo,
						link: tempData.linkUrl || ''
					}
					this.patentList.list.item.push(dataObj)
				}
			})
			.catch(error => {
				console.log('* error : ' + error.response)
			})

		// partnership
		this.$axios.post(this.$store.state.dataUrl + '/aboutUs?cate=' + 'partnership')
			.then(response => {
				// console.log('partnershipData : ', response.data)
				let data = response.data
				let dataObj
				let tempData
				this.partnerList.list.item = []
				for (var elm in data) {
					dataObj = {}
					tempData = data[elm]
					dataObj = {
						title: tempData.title,
						imgUrl: this.$store.getters.getUrlPrefix + tempData.mainImg,
						category: tempData.cate,
						idx: tempData.aboutUsNo,
						link: tempData.linkUrl || ''
					}
					this.partnerList.list.item.push(dataObj)
				}
			})
			.catch(error => {
				console.log('* error : ' + error.response)
			})

		// console.log('mounted')

		var agent = navigator.userAgent.toLowerCase()
		if ((navigator.appName === 'Netscape' && agent.indexOf('trident') !== -1) || (agent.indexOf('msie') !== -1)) {
			// ie일 경우
			this.ie = true
			document.querySelector('.company.parallaxY').style.backgroundAttachment = 'scroll'
		} else {
			// ie가 아닐 경우
			this.ie = false
			document.querySelector('.company.parallaxY').style.backgroundAttachment = 'fixed'
		}

		this.dH = document.body.scrollHeight
		this.wH = window.innerHeight
		this.wW = window.innerWidth
		if (this.dH > this.wH) {
			this.parallaxState = true
		} else {
			this.parallaxState = false
		}

		document.addEventListener('scroll', this.onScroll)
		this.onScroll()
	},
	destroyed () {
		document.removeEventListener('scroll', this.onScroll)
		window.removeEventListener('resize', this.onWinResize)
	},
	methods: {
		onWinResize (event) {
			this.wW = window.innerWidth
			this.wH = window.innerHeight

			this.offsetPosControll()
		},
		onScroll () {
			if (this.parallaxState) {
				var elm = document.querySelector('.company.parallaxY')
				var sY = window.scrollY
				var calcY = -sY / (this.dH - this.wH)

				if (!this.ie) {
					if ((this.wW < 1600) && (this.wW > 1200)) {
						elm.style.backgroundPosition = 'center ' + Math.round(calcY * this.bgMoveVal * 0.7) + 'px'
					} else if (this.wW < 1200) {
						elm.style.backgroundPosition = 'center ' + Math.round(calcY * this.bgMoveVal * 0.5) + 'px'
					} else {
						elm.style.backgroundPosition = 'center ' + Math.round(calcY * this.bgMoveVal * 4) + 'px'
					}
				}

				this.offsetPosControll()
			}
		},
		offsetPosControll () {
			if (this.parallaxState) {
				var secTop
				/* 중간, 상단 트리거 형태 */
				if (this.$store.state.device !== 'mobile' && this.wW >= 768) {
					// Section Top position
					// 속도 보정
					secTop = this.$refs.sectionAboutCompany.offsetTop

					this.parallScrollTrigger(this.$refs.paral1, secTop, 340)
					this.parallScroll(this.$refs.paralVideo, secTop)
					this.parallScroll(this.$refs.paral2, secTop)
					this.parallScroll(this.$refs.paral3, secTop)
					this.parallScroll(this.$refs.aboutTeamL, secTop)
					this.parallScroll(this.$refs.aboutTeamR, secTop)
				} else {
					// 모바일인 경우 속도 보정 제거
					this.$refs.paral1.style.transform = 'none'
					this.$refs.paralVideo.style.transform = 'none'
					this.$refs.paral2.style.transform = 'none'
					this.$refs.paral3.style.transform = 'none'
					this.$refs.aboutTeamL.style.transform = 'none'
					this.$refs.aboutTeamR.style.transform = 'none'
				}
			}
		},
		parallScrollTrigger (obj, parentTop, topMargin) {
			var sY = window.scrollY
			if ((parentTop + this.getCalculatedPos(obj).y) + (obj.clientHeight / 2) - topMargin < sY) {
				// top
				obj.style.transform = 'translateY(-300%)'
			} else if ((parentTop + this.getCalculatedPos(obj).y) - (this.wH / 2) + (obj.clientHeight / 2) < sY) {
				// middle
				obj.style.transform = 'translateY(-100%)'
			} else {
				obj.style.transform = 'translateY(0)'
			}
		},
		parallScroll (obj, parentTop) {
			// speed 가속형
			var tg = obj
			var sY = window.scrollY
			var speed = tg.dataset.speed

			if ((parentTop + this.getCalculatedPos(tg).y) - this.wH < sY) {
				if (this.getAbsolutePos(tg).y >= -tg.clientHeight) {
					tg.style.transform = 'translateY(' + ((parentTop + this.getCalculatedPos(tg).y - this.wH - sY) / 100 * speed - 100) + 'px)'
				} else {
					// 화면 밖일 경우 예외 처리
				}
			} else {
				tg.dataset.cspeed = 0
				tg.style.transform = 'translateY(0)'
			}
		},
		getCalculatedPos (obj) {
			var left, top
			left = top = 0
			if (obj.offsetParent) {
				do {
					left += obj.offsetLeft
					top += obj.offsetTop
				} while (obj === obj.offsetParent)
			}
			return {
				x: left,
				y: top
			}
		},
		getAbsolutePos (obj) {
			var rect = obj.getBoundingClientRect()
			return { x: rect.left, y: rect.top }
		},
		youtubeClick () {
			this.youtubeThumbShow = false
			this.$refs.youtube.player.playVideo()
		}
	}
}
</script>
<style lang="scss">
.secWrap {
	&.aboutCompany {
		.companyTopVideo {
			iframe {
				height: 100%;
				width: 100%;
			}
		}
	}
}
</style>
<style lang="scss" scoped>
@import '@/css/variables.scss';
.company {
	position: relative;
	padding-top: 88px;
	height: auto;
	width: 100%;
}
.parallaxY {
	&.company {
		background-image: url(../assets/images/bg-company-parallax@2x.jpg);
		background-size: cover;
		background-position-x: center;
		background-position-y: 0;
		background-attachment: fixed;
		/* transition: all 0.3s;
		transition-timing-function: linear; */
	}
}
.parallaxChild {
	&.shadow, .shadow {
		box-shadow: 0px 18px 30px 16px rgba(0,0,0,0.3);
	}
	&.animation {
		transition: 0.3s transform;
	}
}
.secWrap {
	position: relative;
	.topAnchor {
		position: absolute;
		top: 0;
		left: 50%;
	}
	&.aboutCompany {
		$centerW: 720px;
		$mgBetween: 18px;
		position: relative;
		top: 400px; left: 0;
		width:100%; height: 1400px;
		.topCenterVision {
			position: absolute;
			top: 0px;
			left: 50%;
			p {
				// line-height: 1.5em;
				font-size: $text-medium;
				transform: translateX(-50%);
			}
			color: $c-white; text-align: center; font-size: $text-normal;
			opacity: 0.8;
		}
		.mainCategory {
			position: absolute;
			height:max-content; width: 20%; min-width: 240px; max-width: 380px;
			top: 350px; right: 50%;
			margin-right: #{$centerW/2 + $mgBetween};
			z-index: 1;
			.topWrap {
				background-color: $c-white;
				width: 100%;
				text-align: center;
				padding: 25px;
				img {
					width: 30%;
					height: auto;
				}
			}
			.contentWrap {
				background-color: $c-green;
				color: $c-white;
				padding: 40px;
				font-size: $text-normal-small;
				h3 {
					font-weight: bold;
					margin-bottom: 10px;
					font-size: $title-xsmall;
				}
			}
		}
		.companyTopVideo {
			position: absolute;
			top: 450px; left: 50%;
			margin-left: -$centerW/2;
			width: $centerW; height: 405px;
			.youtubeThumb {
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				pointer-events: auto;
				z-index: 877;
			}
		}

		.aboutCompanyIntro {
			position: absolute;
			/* top: 170px; */ top: 320px; left: 50% ;
			margin-left: #{$centerW/2 + $mgBetween};
			height: auto; width: 20%; min-width: 240px; max-width: 380px;
			.topWrap {
				color: $c-white;
				width: 100%;
				text-align: left;
				padding: 25px;
				background:$c-blue-m url(../assets/images/bg-company-aboutcompany-ico@2x.png) 80% bottom no-repeat;
				background-size: 20% auto;
				h3 {
					font-weight: bold;
					margin-bottom: 10px;
					font-size: $title-small;
					p > span {font-size: $title-tiny;}
					> span {font-size: $title-tiny; color: $c-blue;}
				}
			}
			.contentWrap {
				background:$c-white url(../assets/images/bg-company-aboutcompany-btm@2x.png) 84% top no-repeat;
				background-size: 28% auto;
				color: $c-gray;
				padding: 8.5%;
				font-size: $text-small;
				p {
					margin-bottom: 8px;
					// line-height: 1.5em;
				}
				h3 {
					font-weight: bold;
					margin-bottom: 10px;
					font-size: $title-xsmall;
				}
			}
		}
	}
	&.aboutTeam {
		$teamMargin: 10px;
		$teamLeft: 30%;
		$teamRight: 100% - $teamLeft;
		$marginBoth: 40px;
		position: relative;
		width:calc(100% - #{$marginBoth*2}); height: 1010px;
		max-width: $mxSecW;
		margin: 0 auto;
		padding: 200px 0 90px;
		.aboutTeamLeft {
			position: absolute;
			top: 700px; left: 0;
			height: auto; width: calc(#{$teamLeft} + #{$teamMargin/2}); min-width: 280px;
			.topWrap {
				width: 100%;
				img {box-shadow: 0px 16px 16px 3px rgba(8, 8, 38, 0.5);
					display: block;}
			}
			.contentWrap {
				color: $c-gray;
				font-size: $text-small;
				h3 {
					font-weight: bold;
					margin-bottom: 10px;
					font-size: $title-small;
					text-align: right;
					color: $c-white;
					> span {font-size: $title-tiny; color: $c-blue-white;}
					p > span {font-size: $title-tiny;}
					text-shadow: 0px 16px 16px rgba(37, 32, 66, 0.5);
				}
			}
		}

		.aboutTeamRight {
			position: absolute;
			top: 300px; left: calc(#{$teamLeft} + #{$teamMargin/2 + $marginBoth});
			height: auto; width: calc(#{$teamRight} - #{$teamMargin/2 + $marginBoth}); min-width: 280px;
			.topWrap {
				color: $c-white;
				margin-bottom: 20px;
			}
			.contentWrap {
				background-color: rgba($c-blue-m, 0.9);
				padding: 32px;
				h4 {color: $c-blue-light; text-align: right; margin-bottom: 60px;}
				.diagramWrap {
					$dSize: 334px;
					text-align: center;
					.diagram {
						display: inline-block;
						.item {
							position: relative;
							display: inline-block;
							margin-left: -32px;
							&:first-child {
								margin-left: 0;
							}
							width: $dSize;
							height: $dSize;
							.diagramItemWrap {
								position: absolute;
								top: 0; left: 0;
								width: 100%; height: 100%;
								padding: 60px;
								border-radius: 50%;
								background-color: rgba($c-blue-light, 0.11);
								box-shadow: 0 16px 32px rgba(0,0,0,0.12);
								color: $c-white; text-align: center;
								.ico { margin-bottom: 10px;}
								h3 {
									font-weight: bold;
									font-size: $title-small;
									line-height: 1.2em;
								}
								.txt {
									line-height: 1.3em;
								}
							}
							&.strategyNPlanning {
								.ico {
									width: 85px; height: auto;
									margin: 0 auto;}
								h3 {
									margin-bottom: 10px;
									}
							}
							&.siGroup {
								.ico {
									width: 96px; height: auto;
									margin: 0 auto; padding-top: 10px;
								}
								h3 {
									margin-bottom: 16px;
									}
							}
							&.rndLaboratory {
								.ico {
									width: 75px; height: auto;
									margin: 0 auto; padding-top: 16px;
									}
								h3 {
									margin-bottom: 16px;
									}
							}
						}
					}
				}
			}
		}
	}
	&.history {
		position: relative;
		width:100%; height: auto;
		margin: 0 auto 150px;
		padding-top: 90px;
		.topWrap {
			position: relative;
			height: 260px;
			.titleWrap {
				position: absolute; display: block;
				width: calc(50% - 20px);
				top: 20px; left: 0;
				.titleTxt {
					color: $c-white;
					text-align: right;
					line-height: 1.2em;
					font-size: $title-small; font-weight: bold;
					&.first { color: $c-blue-light;}
				}
			}
			.icoWrap {
				position: absolute; display: block;
				width: 160px;
				top: 0; left: 50%;
				margin-left: -10px;
				img {
					width: 100%;
					height: auto;
				}
			}
		}
		.contentWrap {
			/* min-width: 1200px; */
			.historyLists {
				.listItem {
					position: relative;
					border-top: 1px dotted rgba($c-gray-m, 0.8);
					&:nth-child(2n) {
						background: none;
					}
					&:nth-child(2n + 1) {
						background-color: rgba($c-blue-m, 0.2);
					}
					.year {
						position: absolute;
						top: - 35px; left: 50%;
						width: 170px; height: 70px;
						margin-left: -85px;
						line-height: 64px;
						color: $c-white; font-size: $title-small; text-align: center; font-weight: bold;
						border: 2px solid $c-white; border-radius: 40px;
						background-color: $c-blue-dark;
					}
					&:first-child .year {
						color: $c-blue-dark;
						background-color: $c-white;
					}
					.contentInnerWrap {
						width: $mxW;
						margin: 0 auto;
						.flexWrap {
							display: flex;
							flex-wrap: wrap;
							.flexContent {
								$historyPd: 90px;
								width: 50%;
								padding: 50px 0 80px;
								&:nth-child(2n) {padding-left: $historyPd;}
								&:nth-child(2n + 1) {border-right: 2px solid rgba($c-black, 0.8); padding-right: $historyPd;}
								h5 {
									color: $c-white;
									font-weight: bold; font-size: $title-small;
									margin-bottom: 20px;
								}
								.txtCont {
									color: $c-gray-light;
									font-size: $text-normal;
									// line-height: 1.5em;
								}
							}
						}
					}
				}
			}
		}
		.bottomWrap {
			border-top: 8px solid rgba($c-white, 0.32);
			position: relative;
			$h: 70px;
			padding-bottom: 80px;
			.titleWrap {
				position: absolute;
				width: 400px; height: $h;
				top: -35px; left: 50%;
				margin-left: -200px;
				background-color: $c-white;
				border-radius: 70px;
				font-size: $title-small; text-align: center; line-height: #{$h - 2px};
				.yearTxt {
					display: inline-block;
					color: $c-blue-dark; font-weight: bold;
					margin-right: 10px;
				}
				.titleTxt {
					display: inline-block;
					color: $c-gray;
				}
			}
		}
	}
	&.certification {
		$iconW: 108px;
		position: relative;
		width:100%; height: auto;
		margin: 0 auto 150px; padding-top: 90px;
		.topWrap {
			position: relative;
			height: 260px;
			width: 480px;
			margin: 0 auto;
			.titleWrap {
				position: absolute; display: block;
				width: calc(100% - #{$iconW*2});
				top: 48px; left: 50%;
				transform: translateX(-50%);
				.titleTxt {
					color: $c-white;
					text-align: center;
					line-height: 1.2em;
					font-size: $title-small; font-weight: bold;
					&.first { color: $c-gray-light2;}
					&.second { color: $c-white;}
					&.third { color: $c-white;}
				}
			}
			.icoWrapL {
				position: absolute;
				top: 0; left: 0;
				width: $iconW; height: auto;
				img {width: 100%;}
			}
			.icoWrapR {
				position: absolute;
				top: 0; right: 0;
				width: $iconW; height: auto;
				img {width: 100%;}
			}
		}
		.contentWrap {
			max-width: $mxW;
			margin: 0 auto;
			.certificationLists {
				display: flex;
				width: 100%;
				margin: 0 auto;
				justify-content: center;
				flex-wrap: wrap;
				.listItem {
					width: 200px;
					padding: 12px 22px 22px;
					background-color: #fff;
					border-radius: 10px;
					margin: 5px 22px;
					.titleTxt {
						display: flex;
						align-items: center;
						color: $c-gray;
						height: 42px;
						margin-bottom: 8px;
						text-align: center; font-size: $title-xtiny; letter-spacing: -0.05em; word-break: keep-all; font-weight: bold;
						span {
							display: block;
							width: 100%;
						}
					}
					.contentInnerWrap {
						width: 153px; height: 214px;
						border: 1px solid $c-gray-light2;
						.imgWrap {
							img {
								max-height: 214px;
							}
						}
					}
				}
			}
		}
	}

	&.patent {
		$innerW: 900px;
		$iconW: 108px;
		position: relative;
		width:100%; height: auto;
		margin: 0 auto 150px; padding-top: 90px;
		.topWrap {
			position: relative;
			height: 170px;
			width: $innerW;
			margin: 0 auto;
			overflow: hidden;
			.titleWrap {
				position: absolute; display: block;
				width: 100%;
				top: 19px; left: 86px;
				.titleTxt {
					color: $c-white;
					padding-left: 40px;
					width: 100%;
					text-align: left; line-height: 1.2em;
					font-size: $title-small; font-weight: bold;
					&.first {
						display: inline-block;
						color: $c-yellow; font-size: $title-medium;
						border-bottom: 1px solid $c-white;
					}
					&.second { color: $c-white; margin-top: 8px;}
				}
			}
			.icoWrap {
				position: absolute;
				top: 0; left: 0;
				width: $iconW; height: auto;
				img {width: 100%;}
			}
		}
		.contentWrap {
			max-width: $innerW;
			margin: 0 auto;
			.patentLists {
				display: flex;
				width: $innerW;
				margin: 0 auto;
				justify-content: flex-end;
				flex-wrap: wrap;
				.listItem {
					width: 200px;
					padding: 12px 22px 22px;
					background-color: #fff;
					border-radius: 10px;
					margin: 5px 17px;
					.titleTxt {
						display: flex;
						align-items: center;
						color: $c-gray;
						height: 42px;
						margin-bottom: 8px;
						text-align: center; font-size: $title-xtiny; letter-spacing: -0.05em; word-break: keep-all; font-weight: bold;
						span {
							display: block;
							width: 100%;
						}
					}
					.contentInnerWrap {
						width: 153px; height: 214px;
						border: 1px solid $c-gray-light2;
						.imgWrap {
							img {
								max-height: 214px;
							}
						}
					}
				}
			}
		}
	}

	&.partner {
		$iconW: 108px;
		position: relative;
		width:100%; height: auto;
		margin: 0 auto 150px;
		max-width: $mxSecW;
		padding-top: 90px;
		.topWrap {
			position: relative;
			height: 140px;
			width: $mxW;
			margin: 0 auto;
			.titleWrap {
				position: absolute; display: block;
				width: 100%;
				top: 19px; left: 0;
				.titleTxt {
					color: $c-white;
					width: 100%;
					text-align: left; line-height: 1.2em;
					font-size: $title-tiny;
					&.first {
						color: $c-green; font-size: $title-medium; font-weight: bold; margin-bottom: 10px;
					}
					&.second { color: $c-white;}
				}
			}
			.icoWrap {
				position: absolute;
				top: 0; left: 0;
				width: $iconW; height: auto;
				img {width: 100%;}
			}
		}
		.contentWrap {
			width: $mxW;
			margin: 0 auto;
			.partnerLists {
				display: flex;
				width: 100%;
				margin: 0 auto;
				flex-wrap: wrap;
				justify-content: space-between;
				.listItem {
					width: 20%;
					min-width: 200px;
					border-radius: 10px;
					margin: 0 0 4px;
					.titleTxt {
						display: flex;
						align-items: center;
						color: $c-white;
						height: 36px;
						margin-bottom: 8px;
						text-align: center; font-size: $title-xtiny; letter-spacing: -0.05em; word-break: keep-all; font-weight: bold;
						span {
							display: block;
							width: 100%;
						}
					}
					.contentInnerWrap {
						/* width: 100%; */width:96%; max-width: 218px; height: 136px;
						margin: 0 auto;
						background-color: $c-white;
						border-radius: 6px;
						.imgWrap {
							img {
								/* max-height: 88%;
								max-width: 164px; */
								width: 60%;
								height: auto;
							}
						}
					}
				}
			}
		}
	}
}
/* for diagram */
@media (min-width: 1025px) and (max-width: 1600px) {
	.secWrap {
		&.aboutTeam {
			$teamMargin: 10px;
			$teamLeft: 28%;
			$teamRight: 100% - $teamLeft;
			$marginBoth: 32px;
			.aboutTeamRight {
				.topWrap {
					margin-bottom: 16px;
				}
				.contentWrap {
					padding: 30px;
					h4 {
						margin-bottom: 50px;
					}
					.diagramWrap {
						$dSize: 304px;
						zoom: 0.8;
						.diagram {
							.item {
								margin-left: -30px;
								width: $dSize;
								height: $dSize;
								.diagramItemWrap {
									padding: 50px;
									.ico { margin-bottom: 10px;}
									h3 {
										font-weight: bold;
										font-size: $title-small;
										line-height: 1.2em;
									}
									.txt {
										line-height: 1.2em;
									}
								}
								&.strategyNPlanning {
									.ico {
										width: 74px;
										}
									h3 {
										margin-bottom: 10px;
										}
								}
								&.siGroup {
									.ico {
										width: 86px;
										padding-top: 10px;
									}
									h3 {
										margin-bottom: 16px;
										}
								}
								&.rndLaboratory {
									.ico {
										width: 65px;
										padding-top: 16px;
										}
									h3 {
										margin-bottom: 16px;
										}
								}
							}
						}
					}
				}
			}
		}
	}
}

/*
  ##Device = Laptops, Desktops
  ##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
	.parallaxY {
		&.company {
			background-size: 110% auto;
		}
	}
	.secWrap {
		$ratio: 0.9;
		&.aboutCompany {
			$centerW: 540px;
			$mgBetween: 12px;
			.topCenterVision {
				p { font-size: $text-medium * $ratio; }
			}
			.mainCategory {
				width: 20%; min-width: 240px; max-width: 380px;
				top: 350px; right: 50%;
				margin-right: #{$centerW/2 + $mgBetween};
				.topWrap {
					padding: 24px;
					img {
						width: 28%;
					}
				}
			}
			.companyTopVideo {
				top: 450px; left: 50%;
				margin-left: -$centerW/2;
				width: $centerW; height: 304px;
			}
			.aboutCompanyIntro {
				width: 20%; min-width: 240px; max-width: 380px;
				top: 280px; left: 50%;
				margin-left: #{$centerW/2 + $mgBetween};
				.topWrap {
					h3 {
						font-size: $title-small * $ratio;
					}
				}
				.contentWrap {
					padding: 24px;
					font-size: $text-small * $ratio;;
					h3 {
						margin-bottom: 8px;
						font-size: $title-xsmall * $ratio;;
					}
				}
			}
		}
		&.aboutTeam {
			$teamMargin: 10px;
			$teamLeft: 30%;
			$teamRight: 100% - $teamLeft;
			$marginBoth: 40px;
			.aboutTeamLeft {
				top: 540px; right: 0; left: auto;
				width: calc(#{$teamLeft} + #{$teamMargin/2});
				z-index: 1;
				.contentWrap {
					font-size: $text-small;
					position: absolute;
					right: 20px;
					bottom: 20px;
				}
			}
			.aboutTeamRight {
				top: 370px; left: $marginBoth;
				width: calc(100% - #{$marginBoth});
				.topWrap {
					color: $c-white;
					margin-bottom: 20px;
				}
				.contentWrap {
					padding: 45px;
					h4 {
						margin-bottom: 60px;
					}
					.diagramWrap {
						$dSize: 334px;
						.diagram {
							.item {
								margin-left: -30px;
								width: 340px;
								height: 340px;
								.diagramItemWrap {
									padding: 60px;
									.ico { margin-bottom: 10px;}
									h3 {
										font-weight: bold;
										font-size: $title-small;
										line-height: 1.2em;
									}
									.txt {
										line-height: 1.3em;
									}
								}
								&.strategyNPlanning {
									.ico {
										width: 85px; height: auto;
										margin: 0 auto;}
									h3 {
										margin-bottom: 10px;
										}
								}
								&.siGroup {
									.ico {
										width: 96px; height: auto;
										margin: 0 auto; padding-top: 10px;
									}
									h3 {
										margin-bottom: 16px;
										}
								}
								&.rndLaboratory {
									.ico {
										width: 75px; height: auto;
										margin: 0 auto; padding-top: 16px;
										}
									h3 {
										margin-bottom: 16px;
										}
								}
							}
						}
					}
				}
			}
		}
		&.history {
			.contentWrap {
				.historyLists {
					.listItem {
						.contentInnerWrap {
							width: $mxWDTSmall - $scrW;
							.flexWrap {
								.flexContent {
									h5 {
										font-size: $title-xsmall;
									}
									.txtCont {
										font-size: $text-normal-small;
									}
								}
							}
						}
					}
				}
			}
		}
		&.certification {
			.contentWrap {
				width: $mxWDTSmall - $scrW;
			}
		}
		&.patent {
			.topWrap {
				width: $mxWDTSmall - $scrW;
			}
			.contentWrap {
				width: $mxWDTSmall - $scrW;
				.patentLists {
					width: calc(100% - 40px);
				}
			}
		}
		&.partner {
			.topWrap {
				width: $mxWDTSmall - $scrW;
			}
			.contentWrap {
				width: $mxWDTSmall - $scrW;
			}
		}
	}
}

/*
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	.parallaxY {
		&.company {
			background-size: auto 110%;
		}
	}
	.secWrap {
		$ratio: 0.9;
		$padding: 40px;
		&.aboutCompany {
			$centerW: 580px;
			$mgBetween: 16px;
			top: 280px;
			.topCenterVision {
				top: 0px;
				left: 70%;
				p { font-size: $text-medium * $ratio; }
			}
			/* 주요 사업 분야 */
			.mainCategory {
				width: $centerW/2; min-width: auto; max-width: none;
				top: 250px; left: $padding; right: auto;
				margin-left: 0;
				.topWrap {
					padding: 24px;
					img {
						width: 28%;
					}
				}
			}
			.companyTopVideo {
				top: 390px; left:auto; right: $padding;
				margin-left: 0;
				width: $centerW; height: 326px;
			}
			/* 회사소개 */
			.aboutCompanyIntro {
				width: $centerW; min-width: auto; max-width: none;
				top: 730px; left: $padding;
				margin-left: 0;
				.topWrap {
					h3 {
						font-size: $title-small * $ratio;
					}
				}
				.contentWrap {
					padding: 34px;
					font-size: $text-small * $ratio;;
					h3 {
						margin-bottom: 8px;
						font-size: $title-xsmall * $ratio;;
					}
				}
			}
		}
		&.aboutTeam {
			$teamMargin: 10px;
			$teamLeft: 30%;
			$teamRight: 100% - $teamLeft;
			$marginBoth: 40px;
			.aboutTeamLeft {
				top: 600px; right: 0; left: auto;
				width: calc(#{$teamLeft} - #{$teamMargin/2});
				min-width: auto;
				z-index: 1;
				.contentWrap {
					font-size: $text-small;
					position: absolute;
					right: 20px;
					bottom: 20px;
				}
			}
			.aboutTeamRight {
				top: 370px;
				// left: $marginBoth;
				left: 0;
				// width: calc(100% - #{$marginBoth});
				width: 100%;
				.topWrap {
					color: $c-white;
					margin-bottom: 20px;
					width: calc(#{$teamRight} - #{$marginBoth});
				}
				.contentWrap {
					padding: 30px 30px 40px;
					h4 {
						margin-bottom: 30px;
					}
					.diagramWrap {
						$dSize: 300px;
						zoom: 0.7;
						.diagram {
							.item {
								margin-left: -34px;
								width: $dSize;
								height: $dSize;
								.diagramItemWrap {
									padding: 50px;
									.ico { margin-bottom: 10px;}
									h3 {
										font-weight: bold;
										font-size: $title-small;
										line-height: 1.2em;
									}
									.txt {
										line-height: 1.2em;
									}
								}
								&.strategyNPlanning {
									.ico {
										width: 74px;
										}
									h3 {
										margin-bottom: 10px;
										}
								}
								&.siGroup {
									.ico {
										width: 86px;
										padding-top: 10px;
									}
									h3 {
										margin-bottom: 16px;
										}
								}
								&.rndLaboratory {
									.ico {
										width: 65px;
										padding-top: 16px;
										}
									h3 {
										margin-bottom: 16px;
										}
								}
							}
						}
					}
				}
			}
		}
		&.history {
			.contentWrap {
				.historyLists {
					.listItem {
						.contentInnerWrap {
							width: $mxWTablet - $scrW;
							.flexWrap {
								.flexContent {
									padding: 50px 20px 52px;
									&:nth-child(2n + 1) {
										padding-right: 52px;
									}
									&:nth-child(2n) {
										padding-left: 52px;
									}
									h5 {
										font-size: $title-xsmall;
									}
									.txtCont {
										font-size: $text-small;
									}
								}
							}
						}
					}
				}
			}
		}
		&.certification {
			.contentWrap {
				width: $mxWTablet - $scrW;
			}
		}
		&.patent {
			.topWrap {
				width: $mxWTablet - $scrW;
			}
			.contentWrap {
				width: $mxWTablet - $scrW;
				.patentLists {
					width: calc(100% - 40px);
				}
			}
		}
		&.partner {
			.topWrap {
				width: $mxWTablet - $scrW;
			}
			.contentWrap {
				width: $mxWTablet - $scrW;
				.partnerLists {
					.listItem {
						min-width: 180px;
						.contentInnerWrap {
							height: 112px;
						}
					}
				}
			}
		}
	}
}

/*
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 1024px
  // (min-width: 768px) and (max-width: 1024px)
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  //CSS
	.parallaxY {
		&.company {
			background-size: 116% auto;
		}
	}
	.secWrap {
		$ratio: 0.9;
		$padding: 40px;
		&.aboutCompany {
			$centerW: 580px;
			$mgBetween: 16px;
			top: 280px;
			.topCenterVision {
				top: 0px;
				left: 70%;
				p { font-size: $text-medium * $ratio; }
			}
			/* 주요 사업 분야 */
			.mainCategory {
				width: $centerW/2; min-width: auto; max-width: none;
				top: 250px; left: $padding; right: auto;
				margin-left: 0;
				.topWrap {
					padding: 24px;
					img {
						width: 28%;
					}
				}
			}
			.companyTopVideo {
				top: 390px; left:auto; right: $padding;
				margin-left: 0;
				width: $centerW; height: 326px;
			}
			/* 회사소개 */
			.aboutCompanyIntro {
				width: $centerW; min-width: auto; max-width: none;
				top: 730px; left: $padding;
				margin-left: 0;
				.topWrap {
					h3 {
						font-size: $title-small * $ratio;
					}
				}
				.contentWrap {
					padding: 34px;
					font-size: $text-small * $ratio;;
					h3 {
						margin-bottom: 8px;
						font-size: $title-xsmall * $ratio;;
					}
				}
			}
		}
		&.aboutTeam {
			$teamMargin: 10px;
			$teamLeft: 30%;
			$teamRight: 100% - $teamLeft;
			$marginBoth: 40px;
			.aboutTeamLeft {
				top: 600px; right: 0; left: auto;
				// width: calc(#{$teamLeft} - #{$teamMargin/2});
				width: 30vw;
				min-width: auto;
				z-index: 1;
				.contentWrap {
					font-size: $text-small;
					position: absolute;
					right: 20px;
					bottom: 20px;
				}
			}
			.aboutTeamRight {
				top: 370px;
				left: 0;
				width: 100%;
				.topWrap {
					color: $c-white;
					margin-bottom: 20px;
					// width: calc(#{$teamRight} - #{$marginBoth});
					width: calc(70vw - 80px - 30px);
				}
				.contentWrap {
					padding: 30px 30px 40px;
					h4 {
						margin-bottom: 30px;
					}
					.diagramWrap {
						$dSize: 304px;
						zoom: 0.7;
						.diagram {
							.item {
								margin-left: -30px;
								width: $dSize;
								height: $dSize;
								.diagramItemWrap {
									padding: 50px;
									.ico { margin-bottom: 10px;}
									h3 {
										font-weight: bold;
										font-size: $title-small;
										line-height: 1.2em;
									}
									.txt {
										line-height: 1.2em;
									}
								}
								&.strategyNPlanning {
									.ico {
										width: 74px;
										}
									h3 {
										margin-bottom: 10px;
										}
								}
								&.siGroup {
									.ico {
										width: 86px;
										padding-top: 10px;
									}
									h3 {
										margin-bottom: 16px;
										}
								}
								&.rndLaboratory {
									.ico {
										width: 65px;
										padding-top: 16px;
										}
									h3 {
										margin-bottom: 16px;
										}
								}
							}
						}
					}
				}
			}
		}
		&.history {
			.contentWrap {
				.historyLists {
					.listItem {
						.contentInnerWrap {
							width: $mxWTablet - $scrW;
							.flexWrap {
								.flexContent {
									h5 {
										font-size: $title-xsmall;
									}
									.txtCont {
										font-size: $text-normal-small;
									}
								}
							}
						}
					}
				}
			}
		}
		&.certification {
			.contentWrap {
				width: $mxWTablet - $scrW;
			}
		}
		&.patent {
			.topWrap {
				width: $mxWTablet - $scrW;
			}
			.contentWrap {
				width: $mxWTablet - $scrW;
				.patentLists {
					width: calc(100% - 40px);
				}
			}
		}
		&.partner {
			.topWrap {
				width: $mxWTablet - $scrW;
			}
			.contentWrap {
				width: $mxWTablet - $scrW;
			}
		}
	}
}

/*
  ##Device = Low Resolution Tablets, Mobiles (Landscape)
  ##Screen = B/w 481px to 767px
*/
@media (min-width: 480px) and (max-width: 767px) {
	.parallaxY {
		&.company {
			background-size: auto 110%;
		}
	}
	.secWrap {
		// $ratio: 0.9;
		&.aboutCompany {
			padding: 0 20px;
			margin-top: calc(20vh + 74px);
			height: auto;
			top: 0;
			.topCenterVision {
				position: relative;
				left: unset;
				padding-bottom: 20vh;
				p {
					// font-size: $text-normal-small;
					font-size: $text-small;
					transform: none;
				}
			}
			// 주요사업분야
			.mainCategory {
				position:relative;
				width: 100%; min-width: unset; max-width: 480px;
				top: unset;
				right: unset;
				margin-right: 0;
				margin: 0 auto 15vh;
				height: auto;
				.topWrap {
					padding: 20px;
					img {
						max-width: 90px;
					}
				}
				.contentWrap {
					text-align: center;
					p {
						line-height: 1.8em;
					}
				}
			}
			// 비디오
			.companyTopVideo {
				position: relative;
				top: unset; left: unset;
				margin-left: unset; margin: 0 auto 15vh;
				width: 100%; max-width: 480px;
				height: 210px;
				.imgWrap {
					img {
						position: unset;
						top: unset; left: unset;
						transform: unset;
					}
				}
			}
			// 회사소개
			.aboutCompanyIntro {
				position: relative;
				top: unset;
				left: unset;
				margin-left: unset;
				margin: 0 auto 15vh;
				width: 100%; max-width: 480px;
				.topWrap {
					background-position-x: calc(100% - 44px);
					background-size: 80px auto;
				}
				.contentWrap {
					background-position-x: calc(100% - 30px);
					background-size: 110px auto;
				}
			}
		}
		&.aboutTeam {
			position: relative;
			top: auto;
			width: 100%;
			margin: 0 auto 15vh;
			padding: 0 20px 0;
			height: auto;
			.aboutTeamLeft {
				position: relative;
				top: unset;
				left: unset;
				width: 100%;
				min-width: unset;
				.contentWrap {
					position: absolute;
					bottom: 20px;
					right: 20px;
				}
			}
			.aboutTeamRight {
				position: relative;
				top: unset;
				left: unset;
				height: auto;
				width: 100%;
				min-width: unset;
				.topWrap {
					padding: 30px;
					background: rgba(26,60,80,.75);
					margin: 0;
				}
				.contentWrap {
					h4 {
						margin-bottom: 40px;
						font-size: $text-tiny;
						text-align: center;
					}
					.diagramWrap {
						.diagram {
							max-width: 400px;
							margin: 0 auto;
							.item {
								width: 200px;
								height: 200px;
								margin-left: 0;
								&:first-child {
									margin-top: 0;
									margin-right: -35px;
								}
								&:last-child {
									margin-top: -65px;
								}
								.diagramItemWrap {
									padding: 38px;
									.ico {
										width: 50px;
									}
									h3 {
										font-size: $title-xtiny;
										margin-bottom: 6px;
									}
									.txt {
										font-size: $text-xtiny;
										font-weight: 300;
									}
								}
								&.rndLaboratory {
									.ico {
										padding-top: 0;
									}
								}
							}
						}
					}
				}
			}
		}

		// 연혁
		&.history {
			padding: 60px 0 0;
			margin: 90px auto 80px;
			.topWrap {
				width: 100%;
				height: 150px;
				.titleWrap {
					left: 40px;
					.titleTxt {
						font-size: $title-small;
						text-align: left;
					}
				}
				.icoWrap {
					width: 60px;
					top: -60px;
					left: 40px;
					margin-left: 0;
				}
			}
			.contentWrap {
				position: relative;
				.verticalLine {
					position: absolute;
					display: block;
					width: 2px;
					height: 100%;
					left: 40px;
					background-color: rgba($c-white, 0.45);
				}
				.historyLists {
					.listItem {
						.year {
							width: 130px;
							height: 50px;
							margin-left: 0;
							font-size: $title-xsmall;
							line-height: 47px;
							top: -25px;
							left: 0;
							border-radius: 0 40px 40px 0;
							border-left: none;
						}
						.contentInnerWrap {
							width: 100%;
							.flexWrap {
								.flexContent {
									width: 100%;
									padding: 65px 20px 65px 90px;
									&:nth-child(2n) {
										padding-top:0;
									}
									&:nth-child(2n + 1) {
										padding-bottom: 30px;
										padding-right: 20px;
										border: none;
									}
									h5 {
										margin-bottom: 5px;
										font-size: $title-xsmall;
									}
									.txtCont {
										font-size: $text-small;
									}
								}
							}
						}
					}
				}
			}
			.bottomWrap {
				padding-bottom: 25px;
				.titleWrap {
					width: calc(100% - 40px);
					height: 60px;
					margin-left: 0;
					left: 20px;
					font-size: $title-normal-small;
					line-height: 60px;
				}
			}
		}

		// 인증 현황
		&.certification {
			padding: 90px 30px 0;
			margin:0 auto 80px;
			.topWrap {
				width: 100%;
				max-width: 300px;
				height: 130px;
				margin-bottom: 30px;
				.titleWrap {
					width: calc(100% - 140px);
					top: 24px;
					.titleTxt {
						font-size: $title-xsmall;
					}
				}
				.icoWrapL,
				.icoWrapR {
					width: 70px;
				}
			}
			.contentWrap {
				.certificationLists {
					.listItem {
						width: calc(33.33% - 6px);
						margin: 0 9px 15px 0;
						padding: 12px 18px 18px;
						&:nth-child(3n) {
							margin-right: 0;
						}
						.titleTxt {
							font-size: $text-tiny;
						}
						.contentInnerWrap {
							width: 100%;
							height: auto;
							.imgWrap {
								img {
									display: block;
									max-height: unset;
									position: static;
									top: unset;
									left: unset;
									transform: none;
								}
							}
						}
					}
				}
			}
		}

		// 특허 현황
		&.patent {
			padding: 90px 30px 0;
			margin:0 auto 80px;
			.topWrap {
				width: 100%;
				max-width: 300px;
				height:100px;
				margin-bottom: 30px;
				.titleWrap {
					width: calc(100% - 56px);
					top: 14px;
					left: 56px;
					.titleTxt {
						padding-left: 25px;
						font-size: $title-tiny;
						&.first {
							padding-bottom: 5px;
							font-size: $title-xsmall;
						}
						&.second {
							padding-top: 5px;
							font-size: $title-tiny;
						}
					}
				}
				.icoWrap {
					width: 70px;
				}
			}
			.contentWrap {
				.patentLists {
					width: 100%;
					justify-content: flex-start;
					.listItem {
						width: calc(33.33% - 6px);
						margin: 0 9px 15px 0;
						padding: 12px 18px 18px;
						&:nth-child(3n) {
							margin-right: 5px;
						}
						&:last-child {
							margin-right: 0;
						}
						.titleTxt {
							font-size: $text-xtiny;
						}
						.contentInnerWrap {
							width: 100%;
							height: auto;
							.imgWrap {
								img {
									display: block;
									max-height: unset;
									position: static;
									top: unset;
									left: unset;
									transform: none;
								}
							}
						}
					}
				}
			}
		}

		// 고객현황
		&.partner {
			padding: 90px 30px 0;
			margin:0 auto 80px;
			.topWrap {
				width: 100%;
				height:100px;
				margin-bottom: 30px;
				.titleWrap {
					width: 100%;
					.titleTxt {
						font-size: $title-xsmall;
						text-align: center;
						&.first {
							font-size: $title-xsmall;
							font-weight: bold;
						}
					}
				}
			}
			.contentWrap {
				width:100%;
				.partnerLists {
					width: 100%;
					justify-content: flex-start;
					.listItem {
						width: calc(25% - 5px);
						min-width: unset;
						margin-right: 6px;
						.contentInnerWrap {
							width: 100%;
							max-width: unset;
							height: 15vw;
							.imgWrap {
								img {
									width: 80%;
									max-width: 110px;
									height: auto;
									margin: 0 auto;
									display: block;
								}
							}
						}
						.titleTxt {
							span {
								font-size: $text-tiny;
								font-weight: 500;
							}
						}
						&:nth-child(4n) {
							margin-right: 0;
						}
					}
				}
			}
		}
	}
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	.parallaxY {
		&.company {
			padding-top: 74px;
			background-size: auto 110%;
		}
		.parallaxChild {
			margin-top: 40px;
			&.aboutTeamRight {
			margin-top:	0;
			}
		}
	}
	.secWrap {
		// $ratio: 0.9;
		&.aboutCompany {
			padding: 0 20px;
			margin-top: calc(50vh - 108px - 10vh);
			height: auto;
			top: 0;
			.topCenterVision {
				position: relative;
				left: unset;
				p {
					font-size: $text-small;
					transform: none;
					line-height: 1.7em;
				}
			}
			// 주요사업분야
			.mainCategory {
				position:relative;
				width: 100%;
				min-width: unset;
				max-width: unset;
				top: unset;
				right: unset;
				margin-right: 0;
				margin-top: 20vh;
				height: auto;
				.topWrap {
					padding: 20px;
					img {
						max-width: 80px;
					}
				}
				.contentWrap {
					text-align: center;
					h3 {
						margin-bottom: 20px;
						font-size: $title-xxsmall;
					}
					p {
						font-size: $text-small;
						line-height: 1.8em;
					}
				}
			}
			// 비디오
			.companyTopVideo {
				position: relative;
				top: unset;
				left: unset;
				margin-left: unset;
				width: 100%;
				height: 210px;
				.imgWrap {
					img {
						position: unset;
						top: unset;
						left: unset;
						transform: unset;
					}
				}
			}
			// 회사소개
			.aboutCompanyIntro {
				position: relative;
				top: unset;
				left: unset;
				margin-left: unset;
				width: 100%;
				min-width: unset;
				max-width: unset;
				.topWrap {
					background-position-x: calc(100% - 44px);
					background-size: 70px auto;
				}
				.contentWrap {
					background-position-x: calc(100% - 30px);
					background-size: 100px auto;
				}
			}
		}
		&.aboutTeam {
			width: 100%;
			padding: 0 20px 0;
			height: auto;
			.aboutTeamLeft {
				position: relative;
				top: unset;
				left: unset;
				width: 100%;
				min-width: unset;
				.contentWrap {
					position: absolute;
					bottom: 30px;
					right: 30px;
					h3 {
						margin-bottom: 0;
					}
				}
			}
			.aboutTeamRight {
				position: relative;
				top: unset;
				left: unset;
				height: auto;
				width: 100%;
				min-width: unset;
				.topWrap {
					padding: 30px;
					background: rgba(26,60,80,.75);
					margin: 0;
				}
				.contentWrap {
					h4 {
						margin-bottom: 40px;
						font-size: $text-tiny;
						text-align: center;
					}
					.diagramWrap {
						.diagram {
							.item {
								width: 210px;
								height: 210px;
								margin-left: 0;
								margin-top: -25px;
								&:first-child {
									margin-top: 0;
								}
								.diagramItemWrap {
									padding: 25px;
									.ico {
										width: 60px;
									}
									h3 {
										font-size: $title-tiny;
										margin-bottom: 6px;
									}
									.txt {
										font-size: $text-tiny;
										font-weight: 300;
									}
								}
								&.strategyNPlanning {
									.ico {
										padding-top: 4px;
									}
								}
								&.siGroup {
									.ico {
										padding-top: 13px;
									}
								}
								&.rndLaboratory {
									.ico {
										padding-top: 10px;
									}
								}
							}
						}
					}
				}
			}
		}
		// 연혁
		&.history {
			padding: 60px 0 0;
			margin: 90px auto 80px;
			.topWrap {
				width: 100%;
				height: 150px;
				.titleWrap {
					left: 40px;
					.titleTxt {
						font-size: $title-small;
						text-align: left;
					}
				}
				.icoWrap {
					width: 60px;
					top: -60px;
					left: 40px;
					margin-left: 0;
				}
			}
			.contentWrap {
				position: relative;
				.verticalLine {
					position: absolute;
					display: block;
					width: 2px;
					height: 100%;
					left: 40px;
					background-color: rgba($c-white, 0.45);
				}
				.historyLists {
					.listItem {
						.year {
							width: 130px;
							height: 50px;
							margin-left: 0;
							font-size: $title-xsmall;
							line-height: 47px;
							top: -25px;
							left: 0;
							border-radius: 0 40px 40px 0;
							border-left: none;
						}
						.contentInnerWrap {
							width: 100%;
							.flexWrap {
								.flexContent {
									width: 100%;
									padding: 65px 20px 65px 90px;
									&:nth-child(2n) {
										padding-top:0;
									}
									&:nth-child(2n + 1) {
										padding-bottom: 30px;
										padding-right: 20px;
										border: none;
									}
									h5 {
										margin-bottom: 5px;
										font-size: $title-xsmall;
									}
									.txtCont {
										font-size: $text-small;
									}
								}
							}
						}
					}
				}
			}
			.bottomWrap {
				padding-bottom: 25px;
				border-top: none;
				.titleWrap {
					width: 290px;
					height: 50px;
					margin-left: 0;
					padding-left: 40px;
					padding-right: 30px;
					top: -25px;
					left: 0;
					font-size: $title-xxsmall;
					line-height: 50px;
					border-radius: 0 70px 70px 0;
				}
			}
		}
		// 인증 현황
		&.certification {
			padding: 0 20px 0;
			margin:0 auto 80px;
			.topWrap {
				width: 100%;
				max-width: 300px;
				height: 130px;
				margin-bottom: 30px;
				.titleWrap {
					width: calc(100% - 140px);
					top: 24px;
					.titleTxt {
						font-size: $title-xsmall;
					}
				}
				.icoWrapL,
				.icoWrapR {
					width: 70px;
				}
			}
			.contentWrap {
				.certificationLists {
					width: 94%;
					.listItem {
						width: calc(50% - 6px);
						margin: unset;
						margin-bottom: 10px;
						padding: 12px 14px 14px;
						&:nth-child(2n) {
							margin-left: 6px;
						}
						&:nth-child(2n-1) {
							margin-right: 6px;
						}
						.titleTxt {
							font-size: $text-xtiny;
						}
						.contentInnerWrap {
							width: 100%;
							height: auto;
							.imgWrap {
								img {
									display: block;
									max-height: unset;
									position: static;
									top: unset;
									left: unset;
									transform: none;
								}
							}
						}
					}
				}
			}
		}
		// 특허 현황
		&.patent {
			padding: 0 20px 0;
			margin:0 auto 80px;
			.topWrap {
				width: 100%;
				max-width: 300px;
				height:100px;
				margin-bottom: 30px;
				.titleWrap {
					width: calc(100% - 56px);
					top: 14px;
					left: 56px;
					.titleTxt {
						padding-left: 25px;
						font-size: $title-tiny;
						&.first {
							padding-bottom: 5px;
							font-size: $title-xsmall;
						}
						&.second {
							padding-top: 5px;
							font-size: $title-tiny;
						}
					}
				}
				.icoWrap {
					width: 70px;
				}
			}
			.contentWrap {
				.patentLists {
					width: 90%;
					justify-content: flex-start;
					.listItem {
						width: calc(50% - 6px);
						margin: unset;
						margin-bottom: 10px;
						padding: 12px 14px 14px;
						&:nth-child(2n) {
							margin-left: 6px;
						}
						&:nth-child(2n-1) {
							margin-right: 6px;
						}
						&:last-child {
							margin: 0;
						}
						.titleTxt {
							font-size: $text-xtiny;
						}
						.contentInnerWrap {
							width: 100%;
							height: auto;
							.imgWrap {
								img {
									display: block;
									max-height: unset;
									position: static;
									top: unset;
									left: unset;
									transform: none;
								}
							}
						}
					}
				}
			}
		}
		// 고객현황
		&.partner {
			padding: 0 20px 0;
			margin:0 auto 80px;
			.topWrap {
				width: 100%;
				height:100px;
				margin-bottom: 30px;
				.titleWrap {
					width: 100%;
					.titleTxt {
						font-size: $title-xsmall;
						text-align: center;
						&.first {
							font-size: $title-xsmall;
							font-weight: bold;
						}
					}
				}
			}
			.contentWrap {
				width:100%;
				.partnerLists {
					width: 100%;
					justify-content: flex-start;
					.listItem {
						width: calc(33.33% - 4px);
						min-width: unset;
						margin-right: 6px;
						.contentInnerWrap {
							width: 100%;
							max-width: unset;
							height: 20vw;
							.imgWrap {
								img {
									width: 70%;
									height: auto;
									margin: 0 auto;
									display: block;
								}
							}
						}
						.titleTxt {
							font-size: $text-xtiny;
							span {
								font-weight: 500;
							}
						}
						&:nth-child(3n) {
							margin-right: 0;
						}
					}
				}
			}
		}
	}
}
</style>
